import { Order } from '../components/table/types'
import { EGuildIncomeStatus, EGuildIncomeType, ListTableRow } from '../types'

import { Pagination } from '~/core/pagination'

export type GuildLiveIncomeItem = {
  confirm_time: number
  revenue: number
  status: EGuildIncomeStatus
  title: string
  username: string
  user_id: number
}

export type GuildLiveIncomeResponse = Pagination<{
  data: GuildLiveIncomeItem[] | []
  total: number
}>

export type GuildLiveIncomeTableRowResponse = Pagination<{
  data: ListTableRow<GuildLiveIncomeItem>[] | []
  total: number
}>

export type GuildLiveIncomeParams = {
  start_date: string
  end_date: string
  p: number
  type: EGuildIncomeType
  creator_id: number
}

export enum EIncomeSortableKeys {
  GiftIncome = 'gift_income',
  NobleIncome = 'noble_income',
  SuperfanIncome = 'superfan_income',
  PlayIncome = 'play_income',
}

export type GuildIncomeItem = {
  creator_id: number
  creator_iconurl: string
  creator_username: string
  agent_id: number
  agent_username: string
} & Record<EIncomeSortableKeys, number>

export interface IQuerySearch<T> {
  start_date?: string
  end_date?: string
  search_creator?: string
  search_creator_id?: number
  search_agent?: string
  p?: number
  pagesize?: number
  order?: Order
  order_by?: T
}

export type GuildIncomeParams = {
  start_date: string // 默认：一个月前
  end_date: string // 默认：今天
  search_creator?: string // 通过主播 ID 或主播昵称搜索
  search_agent?: string // 通过经纪人昵称搜索
  p?: number // 默认：1
  sort?: string // 默认：gift_income.desc
}

export type GuildIncomeResponse = Pagination<{
  data: GuildIncomeItem[]
  menu: Record<EIncomeSortableKeys, number>
}>

export type GuildIncomeTableRowResponse = Pagination<{
  data: ListTableRow<GuildIncomeItem>[] | []
  menu: Record<EIncomeSortableKeys, number>
}>
